import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DetalhesLotesComponent } from 'src/app/pages/detalhes-lotes/detalhes-lotes.component';
import { LotesFaturamentoComponent } from './lotes-faturamento.component';

const routes: Routes = [
  {
    path: '',
    component: LotesFaturamentoComponent,
    title: 'Faturamento dos Contratos',
    children: [{ path: ':mode', redirectTo: '', pathMatch: 'full' }]
  },
  {
    path: 'detalhes-lote/:id',
    component: DetalhesLotesComponent,
    title: 'Lote'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LotesFaturamentoRoutingModule {}
